import { ROUTES } from '@/constants/routes'

export default function isAccountNotDisabled({ next, router, store }) {
    const { workspace = {}, account = {} } = store

    if ((workspace && workspace?.owner_blocked) || (account && account.in_paused)) {
        router.push({ name: ROUTES.accountDisabled })
    }

    return next()
}
